import React, { useEffect, useState } from 'react';
import { DataField, DataRow, DropdownModel, MasterListDataOutput, UpdateMasterlistInput } from '../../../data/interfaces/sharedmodels';
import { Box, Button, Container, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Toolbar, Typography } from '@mui/material';
import MasterListServicerlist from '../../../data/api/masterlist.service';
import { showerrormessage, showsuccessmessage } from '../../../stores/notificationslice';
import { useAppDispatch } from '../../../stores/hooks';

export default function Masterlistcreate({ datarow, fieldtype, listType, cancel, callbackupdatelisttype }: { datarow: DataRow | undefined, fieldtype: MasterListDataOutput | null, listType: DropdownModel, cancel: any, callbackupdatelisttype: any }) {
  const [formData, setFormData] = useState<Record<string, any>>({});
  const [selectedOption, setSelectedOption] = useState('');
  const [data, setData] = useState<MasterListDataOutput | null>(fieldtype);
  const [fromCreate, setfromCreate] = useState(Boolean);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (datarow === undefined)
      setfromCreate(true);
    else
      setfromCreate(false);

    // datarow?.Attributes.map(attribute => (

    //   handleInputChange(attribute.Name, attribute.Value)      
    // ));

    datarow?.Attributes.map(attribute => {
      setFormData(formData => ({
        ...formData,
        [attribute.Name]: attribute.Value,
      }));
    });
    console.log(formData);
  }, [datarow]);


  const handleInputChange = (key: string, value: string) => {
    setSelectedOption(value);
    // console.log(formData)
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const renderInputField = (fieldToRender: DataField) => {

    var dropdownModelArray: DropdownModel[] | undefined = [];
    if (data?.FieldLookups != null) {
      dropdownModelArray = data.FieldLookups
        .find(lookup => lookup.FieldName === fieldToRender.Name)
        ?.LookUpValues;
      dropdownModelArray = dropdownModelArray && dropdownModelArray.filter(option => option.Id !== '-99');
      if (data?.FieldLookups
        .find(lookup => lookup.FieldName === fieldToRender.Name)
      ) { fieldToRender.Type = "dropdown"; }

      //  setSelectedOption(fromCreate ? '': datarow?.Attributes.find(a => a.Name===key)?.Value);
      // selectedOption=fromCreate ? '': datarow?.Attributes.find(a => a.Name===key)?.Value;
    }


    switch (fieldToRender.Type) {
      case 'text':
        return (
          <TextField
            label={fieldToRender.Name}
            disabled={fromCreate==false&& fieldToRender?.IsEditable == false}
            required={fieldToRender.IsNullable==false}
            type="text"
            value={formData[fieldToRender.Name]}
            onChange={(e) => handleInputChange(fieldToRender.Name, e.target.value)}
            fullWidth
          />
        );
      case 'number':
        return (
          <TextField
            label={fieldToRender.Name}
            disabled={fromCreate==false&& fieldToRender?.IsEditable == false}
            type="number"
            required={fieldToRender.IsNullable==false}
            //  value={fromCreate ? '': datarow?.Attributes.find(a => a.Name===key)?.Value}
            value={formData[fieldToRender.Name]}
            onChange={(e) => handleInputChange(fieldToRender.Name, e.target.value)}
            fullWidth
          />
        );
      case 'checkbox':
        return (
          <TextField
            label={fieldToRender.Name}
            disabled={ (fromCreate==false&& fieldToRender?.IsEditable == false)}
            required={fieldToRender.IsNullable==false}
            type="checkbox"
            value={fromCreate ? '' : datarow?.Attributes.find(a => a.Name === fieldToRender.Name)?.Value}
            onChange={(e) => handleInputChange(fieldToRender.Name, e.target.value)}
            fullWidth
          />
        );
      case 'dropdown':
        return (


          <FormControl fullWidth>
            <InputLabel>{fieldToRender.Name}</InputLabel>
            <Select
              label={fieldToRender.Name}
              required={fieldToRender.IsNullable==false}
              disabled={(fromCreate==false&& fieldToRender?.IsEditable == false)}

              value={formData[fieldToRender.Name] != undefined ? formData[fieldToRender.Name].toString() : fieldToRender.IsNullable==false ? dropdownModelArray && dropdownModelArray[0].Id && (formData[fieldToRender.Name] = dropdownModelArray[0].Id) : '-99'}
              onChange={(e) => handleInputChange(fieldToRender.Name, e.target.value)}
            >
              {dropdownModelArray && dropdownModelArray.map((option) => (
                <MenuItem key={option.Id} value={option.Id}>
                  {option.Description}
                </MenuItem>
              ))}
            </Select>

          </FormControl>
        );
      // You can add more cases for different data types like number, checkbox, etc.

      default:
        return null;
    }
  };

  const handleCancel = () => {
    cancel(null);
  };

  const handleSave = () => {
    const updateMasterlistInput: UpdateMasterlistInput = {
      MasterListId: data?.MasterListId,
      TocId: 1,
      InputData: {
        Name: "yourNameValue",
        Value: formData
      }
    };
    MasterListServicerlist.updateMasterList(updateMasterlistInput)
      .then((response) => {
        if (response && response.data) {

          dispatch(showsuccessmessage("Updated Successfully!"));
          cancel(null);
          callbackupdatelisttype(data?.MasterListId);


        }
      }).catch((error) => {
        dispatch(showerrormessage("Something went wrong!"));
      })
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Toolbar >
        <Box sx={{ display: 'flex', flex: 1, justifyContent: 'space-between' }}>
          <Typography variant="h6">
            {(fromCreate ? "Create New " : "Edit ") + listType.Description}
          </Typography>

        </Box>
      </Toolbar>

      <Container component="main" maxWidth="xs" sx={{ maxWidth: '300px' }}>


        <form >
          <Grid container spacing={2} >
            {data?.Fields && data.Fields.map((field) => (
              <Grid item xs={12} key={field.Name}>
                {renderInputField(field)}
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px',mb:2 }}>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleSave}
            >
              Save
            </Button>

          </Box>
        </form>

      </Container>

    </Box>
  );
};



